module.exports = __webpack_public_path__ + "static/media/second_logo.6e595847.png";